import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';

import { AuthContext } from '../../../../context';

import Button from '../../../shared/button';
import Modal from '../../../shared/modal';
// import Loader from '../../../shared/loader';
import UserLinks from './user-links'
import NewQuestionForm from '../../../forms/new-question';

import style from './index.module.scss';

class Navbar extends Component {
  static contextType = AuthContext;

  state = {
    open: false,
  };
 
  onOpenModal = () =>
    this.setState({
      open: true,
    });

  onCloseModal = () =>
    this.setState({
      open: false,
    });

  onLogout = () => {
    const { handleAuthentication } = this.context;

    const itemsToRemove = ['quora-token', 'current-user'];

    itemsToRemove.forEach(item => localStorage.removeItem(item));

    handleAuthentication(false, null);

    this.props.history.push('/');
  };

  onLogin = () => {
    this.props.history.push('/auth');
  };

  render() {
    const { open } = this.state;
    const { isAuthenticated } = this.context;

    return (
      <nav
        className={`navbar navbar-expand-lg navbar-light ${style.navbar}`}
      >
        <Link className={`navbar-brand ${style['navbar-brand']}`} to="/">
          <img
            src="https://i.imgur.com/K5gCLXM.png"
            alt="Quora Logo"
            className={style['navbar-brand-img']}
          />
        </Link>
        <div className={`row ${style['navbar-main']}`}>
          <div className={`navbar-nav col-5 ${style['col-menu']}`}>
            <NavLink
              className={`nav-link ${style['nav-link']}`}
              activeClassName={style['nav-link--active']}
              exact
              to="/home"
            >
              <i className={`fas fa-home ${style['navbar-icon']}`} /> Home{' '}
            </NavLink>
            <NavLink
              className={`nav-link ${style['nav-link']}`}
              activeClassName={style['nav-link--active']}
              to="/answer"
            >
              <i className={`far fa-edit ${style['navbar-icon']}`} /> Answer
            </NavLink>
            <NavLink
              className={`nav-link ${style['nav-link']}`}
              activeClassName={style['nav-link--active']}
              to="/notifications"
            >
              <i className={`fas fa-bell ${style['navbar-icon']}`} />{' '}
              Notifications
            </NavLink>
          </div>
          <form
            className={`form-inline my-2 my-lg-0 col-4 ${
              style['col-form']
            }`}
          >
            <input
              className={`form-control mr-sm-2 ${style['search-quora']}`}
              type="search"
              placeholder="Search Quora"
              aria-label="Search"
            />
          </form>
          <div className={`col-3 ${style['col-buttons']}`}>
            <div className={`navbar-account ${style['navbar-account']}`}>
              {isAuthenticated && <UserLinks />}
            </div>
            {isAuthenticated && (
              <>
                <button
                  className={`btn my-2 my-sm-0 ${style['btn-add-question']}`}
                  onClick={this.onOpenModal}
                >
                  Add Question
                </button>
                <Modal
                  isModalOpen={open}
                  isFooterDisplayed={false}
                  openModal={this.onOpenModal}
                  closeModal={this.onCloseModal}
                  label='Add Question'
                >
                  <NewQuestionForm
                    openModal={this.onOpenModal}
                    closeModal={this.onCloseModal}
                  />
                </Modal>
              </>
            )}
            <>
              {!isAuthenticated && (
                <Button
                  isAuthenticated={isAuthenticated}
                  label="Sign in"
                  action={this.onLogin}
                />
              )}
            </>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navbar;
